import * as React from 'react';

import styled from '@emotion/styled';

const StyledMain = styled.main`
	display: flex;
	flex-direction: column;
	flex: 1;
	flex-grow: 2;
	min-height: 50vh;
`

export const Main = ({children}) => (
	<StyledMain>
		{children}
	</StyledMain>
)